module.exports = __webpack_public_path__ + "static/media/Kotak.a732e524.jpg";